import { useEffect, useState } from 'react';
import exifr from 'exifr';
import { isEmpty } from 'rambda';
import { selectInventorizeFormPhotos, useStore } from '../../useStore';
import { parseGpsValue } from './parseGpsValue';

interface GpsLocation {
  hasGeolocationAllowed: boolean;
  loadingGeolocation: boolean;
  handleGetGeolocation: () => void;
}

export function useGpsLocation(handleChange: (parsed: any) => void): GpsLocation {
  const formPhotos = useStore(selectInventorizeFormPhotos);

  const [hasGeolocationAllowed, setHasGeolocationAllowed] = useState('getCurrentPosition' in navigator.geolocation);
  const [loadingGeolocation, setLoadingGeolocation] = useState(false);

  const firstDetailPhoto = formPhotos.originPhotoDetailList[0];

  useEffect(() => {
    async function getGpsCoordinates() {
      if (firstDetailPhoto && !isEmpty(firstDetailPhoto)) {
        const exifrOutput = await exifr.gps(firstDetailPhoto);

        if (!exifrOutput) {
          return;
        }

        const parsed = { lat: parseGpsValue(exifrOutput?.latitude), lng: parseGpsValue(exifrOutput?.longitude) };

        handleChange(parsed);
      }
    }
    getGpsCoordinates();
  }, [firstDetailPhoto, handleChange]);

  const handleGetGeolocation = () => {
    if (!('getCurrentPosition' in navigator.geolocation)) {
      setHasGeolocationAllowed(false);
      return;
    }
    setLoadingGeolocation(true);
    navigator.geolocation.getCurrentPosition(
      position => {
        setHasGeolocationAllowed(true);
        const { latitude, longitude } = position.coords;
        const parsed = { lat: parseGpsValue(latitude), lng: parseGpsValue(longitude) };
        handleChange(parsed);
        setLoadingGeolocation(false);
      },
      () => {
        setHasGeolocationAllowed(false);
        setLoadingGeolocation(false);
      },
    );
  };

  return {
    hasGeolocationAllowed,
    loadingGeolocation,
    handleGetGeolocation,
  };
}
